export default () => ({
  includes: ['address_correspondence', 'active_covenants'],
  entity: 'user',
  user: {
    active_covenants: [],
    phones: {},
    address_correspondence: {}
  },
  loading: true
})



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/identification/resources/data.js